import { isBatchPick } from '../models/batch-status';
import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { BatchService } from '../Services/batch.service';
import { UserService } from '../Services/user.service';
import { StoreService } from '../Services/store.service';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',
  providers: [BatchService, UserService, StoreService]
})
export class DashboardComponent implements OnInit {
  userRole: string = '';
  totalStores: number = 0;
  batches: any[] = [];
  users: any[] = [];
  loading = true;
  showInProgressList = false;

  constructor(
    private batchService: BatchService,
    private userService: UserService,
    private storeService: StoreService,
    private router: Router,
  ) {}

  openBatch(batch: any) {
    const isPick = isBatchPick(batch);
    if (isPick) {
      if (batch.status === 'Pending' || batch.status === 'Picking') {
        this.router.navigate(['/batchpick', batch.batchId, 'pick']);
        return;
      }
      if (batch.status === 'Picked' || batch.status === 'Verifying') {
        this.router.navigate(['/batchpick', batch.batchId, 'verify']);
        return;
      }
    }
    this.router.navigate(['/batch', batch.batchId]);
  }

  ngOnInit() {
    this.userRole = this.userService.checkRole() ?? '';
    this.fetchDashboardData();
  }

  fetchDashboardData() {
    this.loading = true;
    this.userRole = this.userService.checkRole() ?? '';

    this.batchService.getAllBatch().subscribe((batchData: any) => {
      this.batches = batchData.result || [];

      if (this.userRole === 'StoreAdmin') {
        this.userService.getUsers().subscribe((userData: any) => {
          this.users = userData.result || [];
          this.loading = false;
        });
      } else if (this.userRole === 'Admin') {
        this.storeService.getStores().subscribe((storeData: any) => {
          this.totalStores = storeData.result?.length || 0;
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    });
  }

  countByStatus(status: string): number {
    return this.batches.filter(b => b.status === status).length;
  }

  recentBatches(): any[] {
    return [...this.batches]
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
      .slice(0, 10);
  }

  getStatusClass(status: string): string {
    const map: Record<string, string> = {
      Pending: 'ss-status-pending',
      InProgress: 'ss-status-inprogress',
      Completed: 'ss-status-completed',
      Cancelled: 'ss-status-cancelled',
      PartialComplete: 'ss-status-partial',
    };
    return map[status] ?? '';
  }

  getInProgressList(): any[] {
    return this.batches.filter(b => b.status === 'InProgress');
  }

  getMedicationCount(batch: any): number {
    let total = 0;
    if (batch.prescriptions) {
      batch.prescriptions.forEach((p: any) => {
        total += p.medications ? p.medications.length : 0;
      });
    }
    return total;
  }

  openNav() { this.showInProgressList = true; }
  closeNav() { this.showInProgressList = false; }
}
